import { Eyebrow as HecEyebrow } from "hec/components/ui/eyebrow";

import type { RegisteredComponent } from "@builder.io/sdk-react";

import type { EyebrowProps } from "./types";

const Eyebrow: React.FC<EyebrowProps> = ({
  content,
  tag,
  size,
  textColor,
  eyebrowBackgroundColor,
  attributes,
}) => {
  return (
    <HecEyebrow
      tag={tag}
      size={size}
      // Blank = the Eyebrow's own defaults (#000000 text, #E0E0E0 background).
      textColor={textColor || undefined}
      eyebrowBackgroundColor={eyebrowBackgroundColor || undefined}
      {...attributes}
      data-testid="eyebrow-HecEyebrow"
    >
      {content}
    </HecEyebrow>
  );
};

export default Eyebrow;

export const EyebrowDefinition = {
  component: Eyebrow,
  name: "Eyebrow",
  noWrap: true,
  inputs: [
    {
      name: "tag",
      type: "string",
      enum: ["h1", "h2", "h3", "h4", "h5", "h6", "div", "span", "p"],
      defaultValue: "span",
    },
    {
      name: "size",
      type: "string",
      enum: ["large", "small"],
      defaultValue: "large",
    },
    {
      name: "content",
      type: "string",
      defaultValue: "Eyebrow",
    },
    // COM-945: the UI Eyebrow already took both colors; the block never
    // exposed them.
    {
      name: "textColor",
      friendlyName: "Text color",
      type: "color",
      defaultValue: "#000000",
    },
    {
      name: "eyebrowBackgroundColor",
      friendlyName: "Background color",
      type: "color",
      defaultValue: "#E0E0E0",
    },
  ],
} satisfies RegisteredComponent;
